export default __webpack_public_path__ + "static/media/onpath_showcase_1.webp";